export default class DrawableObject {
    render(ctx) {

    }
}